import { render, staticRenderFns } from "./TextareaComponent.vue?vue&type=template&id=65936738&"
import script from "./TextareaComponent.vue?vue&type=script&lang=ts&"
export * from "./TextareaComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports